import Vue from 'vue'
import VueRouter from 'vue-router'

import routes from '@/router/routes'
import store from '@/store'

import Modal from '@/assets/js/modal'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.VUE_APP_WEB_BASE,
  linkActiveClass: 'active',
  linkExactActiveClass: 'active',
  routes
})

router.beforeEach((to, from, next) => {
  // Authentication
  if ( to.matched.some(record => record.meta.requiresAuth) ) {
    if ( !store.getters.isAuthenticated ) {
      next('/account/login');
      return;
    }
  }
  // Admin
  if ( to.matched.some(record => record.meta.onlyAdmin) ) {
    let user = store.getters.getUser;
    if ( !user || !user.admin ) {
      next('/account/login');
      return;
    }
  }
  // Modal close
  if ( Modal.isOpen() ) {
    Modal.hide();
    next(false);
    return;
  }

  // Continue normally
  next();
})

export default router
